



















import { Vue, Component } from "vue-property-decorator";
import { mapState } from "vuex";
import { IState } from "@/store";
import { DataModules } from "@/store/modules/data";
import { Contexts } from "@/models/contexts";

@Component({
  components: {
    "impersonation-ribbon": () =>
      import("@/components/app/global/client/impersonationRibbon.vue"),
    "navigation-ribbon": () => import("./navigationRibbon.vue"),
    "content-ribbon": () => import("./contentRibbon.vue"),
    "client-container": () => import("@/skeleton/client/clientContainer.vue"),
    "profile-dropdown": () =>
      import("@/components/app/global/user/profileDropdown.vue"),
    "notifications-dropdown": () =>
      import(
        "@/components/app/global/userNotifications/userNotificationsDropdown.vue"
      )
  },
  computed: {
    ...mapState({
      ui: (state: IState) => state.ui
    })
  }
})
export default class Client extends Vue {
  public readNotificationsScope = "";
  public unReadNotificationsScope = "";
  // Life-cycle methods
  private created() {
    this.readNotificationsScope = this.$store.getters[
      `data/${DataModules.USER_NOTIFICATIONS}/loggedUserScope`
    ]();
    this.unReadNotificationsScope = this.$store.getters[
      `data/${DataModules.USER_NOTIFICATIONS}/loggedUserUnreadScope`
    ]();
    window.addEventListener("storage", this.onLocalStorageChange);
  }
  private beforeDestroy() {
    window.removeEventListener("storage", this.onLocalStorageChange);
    this.$store.dispatch("data/binList", {
      storeModule: DataModules.USER_NOTIFICATIONS,
      ignoreDependants: true,
      scope: this.readNotificationsScope,
      vm: this
    });
    this.$store.dispatch("data/binList", {
      storeModule: DataModules.USER_NOTIFICATIONS,
      ignoreDependants: true,
      scope: this.unReadNotificationsScope,
      vm: this
    });
  }

  // Methods
  private onLocalStorageChange({ key, oldValue, newValue }) {
    if (!key) return;
    switch (key) {
      case "client/auth/accountId":
        // If accountId changed...
        if (`${oldValue}` !== `${newValue}`)
          // Open session changed modal
          this.$store.dispatch("auth/openSessionChangedModal");
        break;
      default:
        if (key.startsWith(`${Contexts.CLIENT}/auth/token/`) && newValue)
          // Sync new token values from localStorage
          this.$store.commit("auth/updateTokenProperty", {
            context: Contexts.CLIENT,
            key: this.$_.last(key.split("/")),
            value: newValue
          });
        break;
    }
  }
}
